import React from "react";
import ReactDom from "react-dom";
import CompareService from "./compare-service";
import CompareItem from "./compare-item";
import Popup from "../../Shared/Assets/Components/Popup";

export default class CompareComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            isHidden: true,
            popupMessage: "",
            items: this.itemViewModels
        };
    }

    componentDidMount() {
        document.body.addEventListener("compare:add-item", this.onAddItem);
        document.body.addEventListener("compare:remove-item", this.onRemoveItem);
    }

    componentWillUnmount() {
        document.body.removeEventListener("compare:add-item", this.onAddItem);
        document.body.removeEventListener("compare:remove-item", this.onRemoveItem);
    }

    onAddItem = (e) => {
        if (CompareService.canAddMore()) {
            e.detail.translations = this.props.translations;
            CompareService.addItem(e.detail);
            this.setState({ ...this.state, items: this.itemViewModels, isHidden: false });
            return;
        }
        
        this.setState({ popupMessage: this.props.translations.notAddItemsText });
        this.onRemoveItem(e);
    }

    onRemoveItem = (e) => {
        this.removeItem(e.detail);
        this.setState({ ...this.state, items: this.itemViewModels });
    }

    onRemoveItemClick = (item) => {
        this.removeItem(item);
        this.setState({ ...this.state, items: this.itemViewModels });
        this.onPrev();
    }

    onRemoveAll = () => {
        CompareService.getItems().forEach(item => this.removeItem(item));
        this.setState({ ...this.state, items: this.itemViewModels, offset: 0 });
    }

    removeItem = (item) => {
        CompareService.removeItem(item.id);
        document.body.dispatchEvent(new CustomEvent("compare:item-removed", { detail: item }));
    }

    get itemViewModels() {
        const items = CompareService.getItems();
        if (items.length > 0 && items.length < 3) {
            //  Add Placeholders
            let placeholders = [...Array(3 - items.length).keys()].map(x => ({
                type: "placeholder",
                title: this.props.translations.addItemsText,
                imageUrl: ""
            }));

            let translations = this.props.translations;
            placeholders.forEach(function (item) {
                item.translations = translations;
            });

            let totalItems = items.concat(placeholders);
            return totalItems;
        }

        return items;
    }

    onNext = () => {
        if (!this.canGoNext) return;
        this.setState(prev => ({ offset: prev.offset + 1 }));
    }

    onPrev = () => {
        if (!this.canGoPrev) return;
        this.setState(prev => ({ offset: prev.offset - 1 }));
    }

    get canGoNext() {
        return this.state.offset < (this.state.items.length - 3);
    }

    get canGoPrev() {
        return this.state.offset > 0;
    }

    onToggle = () => {
        const { isHidden } = this.state;
        this.setState({ ...this.state, isHidden: !isHidden });
    }

    onClosePopup = () => {
        this.setState({ popupMessage: "" });
    }

    render() {
        const { items, isHidden, offset, popupMessage } = this.state;

        if (items.length <= 0) return null;

        const { comparePageUrl } = this.props;
        const actualItems = items.filter(x => x.type !== "placeholder");
        const canCompare = actualItems.length > 1;
        const ids = items.map(x => x.id).join(",");
        const url = canCompare ? `${comparePageUrl}?ids=${ids}` : "";
        const showNext = this.canGoNext;
        const showPrev = this.canGoPrev;
        const itemCount = actualItems.length;

        const slides = items.map((item, i) => <CompareItem key={i} {...item} onRemoveItem={this.onRemoveItemClick} />);

        const carouselStyle = {
            transform: `translateX(calc((-100%/3)*${offset}))`
        };

        return (
            <div className={"compare-panel " + (isHidden ? "close-panel " : "open-panel ")} data-webm-section="compare-items-panel">
                <Popup isOpen={popupMessage !== ""} onRequestClose={this.onClosePopup} height={550} width={500}>
                    {popupMessage}
                </Popup>
                <div className="compare-panel-wrapper">
                    <div className="container">
                        <div className="d-flex flex-row flex-nowrap h-100 align-items-center">
                            <div className="compare-header">
                                <h2>{this.props.translations.compareText}</h2>
                                <a onClick={this.onToggle} data-webm-clickvalue="hide-panel" > {this.props.translations.hideText} </a>
                            </div>
                            <div className="items">
                                <i className={"prev " + (showPrev ? "" : "disabled")} onClick={this.onPrev}></i>
                                <div className="wrap">
                                    <ul className="carousel" style={carouselStyle} >
                                        {slides}
                                    </ul>
                                </div>
                                <i className={"next " + (showNext ? "" : "disabled")} onClick={this.onNext}></i>
                            </div>
                            <div className="compare-actions">
                                <a className={"btn btn-primary " + (!canCompare ? "disabled" : "")} disabled={!canCompare} href={url} data-webm-clickvalue="compare-button" >
                                    {this.props.translations.compareText} ({itemCount})
                                </a>
                                <a className="btn btn-link remove-all" onClick={this.onRemoveAll} data-webm-clickvalue="remove-all">
                                    {this.props.translations.removeAllText}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <a className="compare-toggle" onClick={this.onToggle} data-webm-clickvalue="show-panel" >
                        {this.props.translations.compareText} ({itemCount})
                    </a>
                </div>
            </div >
        );
    }
}